<template>
  <div>
    <van-nav-bar left-text="All Tasks" left-arrow @click-left="onClickLeft"/>
    <div class="tasks-section">
      <van-list
          v-model:loading="loading"
          :finished="finished"
          loading-text="Loading..."
          @load="onLoad"
      >
        <van-cell-group>
          <van-cell
              v-for="(task, index) in orderlist"
              :key="index"
              center
              :title="task.receiverName"
              :label="task.bankName"
          >
            <template #default>
              <van-button
                  class="receive-button"
                  type="primary"
                  size="small"
                  @click="handleReceive(task)"
              >
                Receive
              </van-button>
            </template>
          </van-cell>
        </van-cell-group>
      </van-list>
    </div>
    <!-- Order Confirmation Popup -->
    <van-popup
        v-model:show="showReceiveConfirm"
        :close-on-click-overlay="false"
        position="center"
        :style="{ width: '80%', padding: '20px' }"
    >
      <p style="font-size: 16px; margin-bottom: 15px">
        Are you sure to accept the order "{{ selectedTask?.orderNo }}"?
      </p>
      <div style="display: flex; justify-content: space-between">
        <van-button
            @click="cancelReceive"
            block
            type="default"
            style="margin-right: 10px"
        >Cancel
        </van-button
        >
        <van-button @click="confirmReceive" block type="primary"
        >Confirm
        </van-button
        >
      </div>
    </van-popup>
    <van-toast
        v-model:show="showSuccessToast"
        message="Order received successfully, please process as soon as possible!"
    />
  </div>
</template>
<script setup>
import { onMounted, ref } from 'vue'
import { receive, receivlist } from '@/utils/api'
import { Dialog, Toast } from 'vant'

const orderlist = ref([])
const loading = ref(false)
const finished = ref(false)
const showReceiveConfirm = ref(false)
const showSuccessToast = ref(false)
const selectedTask = ref(null)
const queryParams = ref({
  pageNum: 1,
  pageSize: 10,
  orderByColumn: 'withdrawAmount',
  isAsc: 'DESC',
  currency: null,
  userId: null,
  withdrawAmount: null,
  receiverName: null,
  receiverAccount: null,
  sourceOrderNo: null,
  orderNo: null,
  withdrawState: null,
  payId: null,
})
const fetchUserData = async () => {
  try {
    queryParams.value.pageNum = 1
    const taskListResponse = await receivlist(queryParams.value)
    orderlist.value = taskListResponse.rows
    // 如果总条数小于等于当前页的数据量，则标记为加载完成
    if (taskListResponse.rows.length >= taskListResponse.total) {
      finished.value = true
    }
  } catch (error) {
    console.error('Error fetching user data:', error)
  }
}
const onLoad = async () => {
  try {
    // 显示加载状态
    loading.value = true
    // 如果是第一页，直接跳过
    if (queryParams.value.pageNum === 1) {
      return
    }
    // 增加页码
    queryParams.value.pageNum++

    // 获取更多数据
    const taskListResponse = await receivlist(queryParams.value)

    // 添加新数据
    if (taskListResponse.rows && taskListResponse.rows.length > 0) {
      // 检测 MyBatis reasonable=true 的情况：如果返回的数据第一条已存在于列表中，说明已经到底了
      const firstNewItemId = taskListResponse.rows[0]?.id
      const isDuplicate = orderlist.value.length > 0 && orderlist.value.some(item => item.id === firstNewItemId)
      
      if (isDuplicate) {
        // 返回的数据与已有数据重复，说明已经到底了（reasonable=true导致返回了第一页）
        finished.value = true
      } else {
        // 正常情况：添加新数据
        orderlist.value = [...orderlist.value, ...taskListResponse.rows]
        // 如果返回的数据少于pageSize，说明已经到底了
        if (taskListResponse.rows.length < queryParams.value.pageSize) {
          finished.value = true
        }
      }
    } else {
      // 没有更多数据
      finished.value = true
    }
  } catch (error) {
    console.error('Error loading more data:', error)
  } finally {
    // 隐藏加载状态
    loading.value = false
  }
}
const handleReceive = (task) => {
  console.log('Received task:', task)
  selectedTask.value = task
  showReceiveConfirm.value = true
}
const cancelReceive = () => {
  showReceiveConfirm.value = false
  selectedTask.value = null
}
const confirmReceive = async () => {
  if (!selectedTask.value) return

  try {
    // Show loading dialog
    Dialog.confirm({
      title: 'Confirm',
      message: `Are you sure to accept the order "${selectedTask.value.orderNo}"?`,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
    })
        .then(async () => {
          console.log(111, selectedTask.value)
          // Execute receive API call
          await receive(selectedTask.value)

          // Refresh task list
          await fetchUserData()

          // Show success toast
          showSuccessToast.value = true
        })
        .catch(() => {
          // Do nothing when canceled
        })
  } catch (error) {
    console.error('Error receiving task:', error)
    Toast.fail('Failed to receive order')
  } finally {
    // Reset states
    showReceiveConfirm.value = false
    selectedTask.value = null
  }
}
const onClickLeft = () => history.back()
onMounted(() => {
  fetchUserData()
})
</script>
<style scoped>
.tasks-section {
  margin: 16px;
}

.van-cell {
  padding: 10px 20px;
  background-color: #f9f9f9;
  border-radius: 20px;
  margin-bottom: 10px;
}

.van-button--primary {
  background-color: orange;
  border-color: orange;
}
</style>
